export default __webpack_public_path__ + "static/media/logo.d91cb8c6.png";